import {
  getCurrentFileStateParamsType,
  GetCurrentFileStateResponseType,
} from '@/common/queries/getCurrentFileState/getCurrentFileState.type';
import { BASE_URL, fetchApi } from '@/config/axiosSetting';

export const getCurrentFileStateQueryFunction = (
  param: getCurrentFileStateParamsType,
): Promise<GetCurrentFileStateResponseType> =>
  fetchApi.get(
    `${BASE_URL}api/v2/app/IRANIAN/adjuster/my_files/${param?.id}/basic_data/`,
    {
      params: {},
    },
  );
